import { httpsCallable } from 'firebase/functions';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncThunkCreator } from '../../../index';
import { SUBSCRIPTION_REDUCER_NAME } from '../types';
import {
  SubscriptionPlan,
  UserSubscriptionInterval,
} from '../../../../models/documents/Subscriptions';

type Payload = {
  interval: UserSubscriptionInterval;
  plan: SubscriptionPlan;
  promotionCode?: string;
};

export const changeSubscriptionPlan = createAsyncThunk<void, Payload, AsyncThunkCreator<number>>(
  `${SUBSCRIPTION_REDUCER_NAME}/changeSubscriptionPlan`,
  async (payload, { rejectWithValue, extra: { functions } }) => {
    try {
      const body = { interval: payload.interval, plan: payload.plan, ...(payload.promotionCode ? { promotionCode: payload.promotionCode } : {}) };
      await httpsCallable(functions, 'subscriptions-changeSubscriptionPlan')(body);
    } catch (e) {
      const error = e as any;

      return rejectWithValue(error.message);
    }

    return;
  }
);
